import { useState } from 'react';
import { useTheme } from '@mui/material';
import { IconArrowLeftSmall, IconArrowRightSmall } from 'assets/icons';
import { StyledArrowButtonLeft, StyledArrowButtonRight } from './styles';
import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';

export function useNavigationHeaderArrows() {
  const { direction } = useTheme();
  const { t } = useOnlineBookingLocale();
  const [scrollDirection, setScrollDirection] = useState({dir: undefined, toggle: undefined });

  const [clickLeft, clickRight] = (() => {
    function clickLeft() { setScrollDirection({dir: -1, toggle: !scrollDirection.toggle}) };
    function clickRight() { setScrollDirection({dir: 1, toggle: !scrollDirection.toggle}) };

    if(direction === 'rtl')
      return [clickRight, clickLeft];

    return [clickLeft, clickRight];
  })();

  function renderArrowButtonLeft() {
    //TODO[YA]: Add title to the button
    return (
      <StyledArrowButtonLeft
        onClick = {clickLeft}
        className = { direction === 'ltr' ? 'StyledArrowButtonLeft' : 'StyledArrowButtonRight' }
        title = { t(`ariaLabel.${direction === 'ltr' ? 'scrollLeft' : 'scrollRight' }`) }
      >
        {
          direction === 'ltr'
          ? <IconArrowLeftSmall />
          : <IconArrowRightSmall />
        }
      </StyledArrowButtonLeft>
    )
  }

  function renderArrowButtonRight() {
    //TODO[YA]: Add title to the button
    return (
      <StyledArrowButtonRight
        onClick = {clickRight}
        className = { direction === 'ltr' ? 'StyledArrowButtonRight' : 'StyledArrowButtonLeft' }
        title = { t(`ariaLabel.${direction === 'ltr' ? 'scrollRight' : 'scrollLeft' }`) }
      >
        {
          direction === 'ltr'
            ? <IconArrowRightSmall />
            : <IconArrowLeftSmall />
        }
      </StyledArrowButtonRight>
    )
  }

  return { renderArrowButtonLeft, renderArrowButtonRight, scrollDirection }
}